import React, { Component } from 'react'

export default ({ className, width, height, onClick }) => {
  return (

    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 38" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>play</title>
      <path fill="#f1f1f1" d="M19,1.14A17.84,17.84,0,0,0,6.38,31.62C9.73,35,14.25,31.45,19,31.45s9.27,3.51,12.62.16A17.86,17.86,0,0,0,19,1.14ZM19,38A19.14,19.14,0,0,1,5.55,32.45,18.91,18.91,0,0,1,0,19,19.14,19.14,0,0,1,5.55,5.55,18.91,18.91,0,0,1,19,0,19.14,19.14,0,0,1,32.45,5.55,18.91,18.91,0,0,1,38,19a19.14,19.14,0,0,1-5.55,13.45A18.91,18.91,0,0,1,19,38Z"/>
      <path fill="#f1f1f1" d="M14.82,25.7v-14c4.06,2.36,7.79,4.51,12.12,7Z"/>
    </svg>


  )
}



// WEBPACK FOOTER //
// ./src/components/visuals/PlayButton.js